import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import CheckboxGroupOTA from '../../../base/components/forms/ota/CheckboxGroupOTA';
import AutoSuggestOTA from '~/features/base/components/forms/ota/AutoSuggestOTA';
import MultiselectOTA from '../../../base/components/forms/ota/MultiselectOTA';
import { useFetchHwVariantsQuery, useFetchVehicleVariantsQuery } from '~/api/controlDevice/ControlDevice.api';
import { CM4, TBM3, VCM } from '~/features/devices/constants/deviceTypes';
import { FILTER_IDS } from '~/features/devices/constants/filterMenuConstants';
import HeartWrapper from '~/features/devices/components/deviceFilters/HeartWrapper';

interface DeviceFiltersSectionProps {
    control: Control<any>;
}

const DeviceFiltersSection: React.FC<DeviceFiltersSectionProps> = ({ control }) => {
    const { data: hwVariants = [] } = useFetchHwVariantsQuery({});
    const { data: vehicleVariants = [] } = useFetchVehicleVariantsQuery({});

    const deviceTypeOptions = [
        { id: CM4, label: CM4 },
        { id: TBM3, label: TBM3 },
        { id: VCM, label: VCM }
    ];
    const vehicleVariantOptions = vehicleVariants.map(variant => ({ id: variant, label: variant }));

    return (
        <div>
            <h4 className={'margin-top-0'}><FormattedMessage id='intl-msg:devices' defaultMessage='Devices'/></h4>
            <div id={FILTER_IDS.DEVICE_TYPE}>
                <HeartWrapper>
                    <Controller
                        name='deviceType'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <CheckboxGroupOTA
                                labelId='intl-msg:deviceType'
                                options={deviceTypeOptions}
                                value={value}
                                onChange={onChange}
                                multiple={true}
                            />
                        )}
                    />
                </HeartWrapper>
            </div>
            <div id={FILTER_IDS.VEHICLE_VARIANT}>
                {vehicleVariants.length > 0 ? (
                    <HeartWrapper key={`vehicle-variant-${vehicleVariants.length}`}>
                        <Controller
                            name='vehicleVariantsWhitelist'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <CheckboxGroupOTA
                                    labelId='intl-msg:vehicleVariant'
                                    options={vehicleVariantOptions}
                                    value={value}
                                    onChange={onChange}
                                    multiple={true}
                                />
                            )}
                        />
                    </HeartWrapper>
                ) : (
                    <Controller
                        name='vehicleVariantsWhitelist'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <CheckboxGroupOTA
                                labelId='intl-msg:vehicleVariant'
                                options={vehicleVariantOptions}
                                value={value}
                                onChange={onChange}
                                multiple={true}
                            />
                        )}
                    />
                )}
            </div>
            <div id={FILTER_IDS.HW_VARIANT_PREFIX}>
                <HeartWrapper>
                    <Controller
                        name='hwVariant'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <AutoSuggestOTA
                                labelId='intl-msg:hwVariantPrefix'
                                options={hwVariants}
                                value={value}
                                onChange={onChange}
                                placeholder='Select hardware variant...'
                            />
                        )}
                    />
                </HeartWrapper>
            </div>
            <div id={FILTER_IDS.HW_VARIANTS}>
                {hwVariants.length > 0 ? (
                    <HeartWrapper key={`hw-variants-${hwVariants.length}`}>
                        <Controller
                            name='hwVariantList'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <MultiselectOTA
                                    labelId='intl-msg:hwVariants'
                                    options={hwVariants}
                                    value={value}
                                    onChange={onChange}
                                />
                            )}
                        />
                    </HeartWrapper>
                ) : (
                    <Controller
                        name='hwVariantList'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <MultiselectOTA
                                labelId='intl-msg:hwVariants'
                                options={hwVariants}
                                value={value}
                                onChange={onChange}
                            />
                        )}
                    />
                )}
            </div>
        </div>
    );
};

export default DeviceFiltersSection;
